import { apiCall } from './gqlClient';

const GENERATEURLFORTRANSLATIONFILE_QUERY = `
  mutation generateUrlForTranslationFile($project: String!, $language: String!) {
    generateUrlForTranslationFile(project: $project, language: $language)
    {
      success
			presignedUrl
      ...fragments
    }
  }`;

export const generateUrlForTranslationFileApiCall = async ({project, language}, fragments = null) => apiCall({ query: GENERATEURLFORTRANSLATIONFILE_QUERY, variables: {project, language}, fragments });
